// extracted by mini-css-extract-plugin
export default {"title":"Section_title__tNjj3","icon":"Section_icon__O8AxY"};